<div class="assay-summary-container" [class.print-mode]="isPrintMode">
  <div class="assay-summary-body">
    <div class="assay-summary-scroll bpx-report" #assaySummaryScroll>
  <!--
    The printed document is unchanged: the run-out of labels below is what has always gone to
    paper, and everything the redesign added is screen-only. What the operator sees on screen is
    the bar plus the same identification as a card.
  -->
  @if (isPrintView) {
  <app-print-preview-bar
    viewName="Assay Summary"
    [studyName]="studyName"
    [contextLine]="printContextLine"
    [tableColumns]="tableColumns"
    (selectColumns)="handlePrintColumnSelection($event)"></app-print-preview-bar>

  <div class="bpx-detail aa-meta bpx-screen-only">
    <div class="bpx-detail__item">
      <span class="bpx-detail__label">Panel Name</span>
      <span class="bpx-detail__value">{{ (panelName$ | async) }}</span>
    </div>
    <div class="bpx-detail__item">
      <span class="bpx-detail__label">Run Type</span>
      <span class="bpx-detail__value">{{ runType }}</span>
    </div>
    <div class="bpx-detail__item">
      <span class="bpx-detail__label">Test Spec</span>
      <span class="bpx-detail__value">{{ testSpec }}</span>
    </div>
    <div class="bpx-detail__item">
      <span class="bpx-detail__label">Assignment Spec</span>
      <span class="bpx-detail__value">Final</span>
    </div>
    <div class="bpx-detail__item">
      <span class="bpx-detail__label">Operator</span>
      <span class="bpx-detail__value">{{ operatorName || '-' }}</span>
    </div>
  </div>

  <div class="bpx-print-only">
    <br />
    Panel Name: <span id="panel-name">{{ (panelName$ | async) }}</span><br />
    Run Type: <span id="run-type">{{ runType }}</span><br />
    Test Spec: <span id="test-spec">{{ testSpec }}</span><br />
    Assignment Spec: <span id="assignment-spec">Final</span><br />
    Operator: <span id="operator">{{ operatorName || '-' }}</span><br /><br />
  </div>
  } @else {
  <div class="bpx-detail aa-meta">
    <div class="bpx-detail__item">
      <span class="bpx-detail__label">Panel Name</span>
      <span class="bpx-detail__value" id="panel-name">{{ (panelName$ | async) }}</span>
    </div>
    <div class="bpx-detail__item">
      <span class="bpx-detail__label">Run Type</span>
      <span class="bpx-detail__value" id="run-type">{{ runType }}</span>
    </div>
    <div class="bpx-detail__item">
      <span class="bpx-detail__label">Test Spec</span>
      <span class="bpx-detail__value" id="test-spec">{{ testSpec }}</span>
    </div>
    <div class="bpx-detail__item">
      <span class="bpx-detail__label">Assignment Spec</span>
      <span class="bpx-detail__value" id="assignment-spec">Final</span>
    </div>
    <div class="bpx-detail__item">
      <span class="bpx-detail__label">Operator</span>
      <span class="bpx-detail__value" id="operator">{{ operatorName || '-' }}</span>
    </div>
  </div>

  <div class="bpx-toolbar__actions aa-actions">
    <a class="bpx-btn" (click)="toggleAllSections(true)">Expand All Sections</a>
    <a class="bpx-btn" (click)="toggleAllSections(false)">Collapse All Sections</a>
    <span class="bpx-toolbar__sep" aria-hidden="true"></span>
    @if (showStabilityOutputs) {
    <a
      (click)="sampleDataLoading ? null : exportAsWorkbook()"
      class="bpx-btn"
      [class.bpx-btn--disabled]="sampleDataLoading || (isStudySaved$ | async) !== true"
      [attr.aria-disabled]="sampleDataLoading || (isStudySaved$ | async) !== true"
      [attr.tabindex]="sampleDataLoading || (isStudySaved$ | async) !== true ? -1 : 0"
      [style.pointer-events]="(isStudySaved$ | async) !== true ? 'none' : null">Export As Workbook</a>
    <a (click)="navigateToPrintView()" class="bpx-btn"
      [class.bpx-btn--disabled]="(isStudySaved$ | async) !== true"
      [attr.aria-disabled]="(isStudySaved$ | async) !== true"
      [style.pointer-events]="((isStudySaved$ | async) !== true) ? 'none' : null">
      <mat-icon fontIcon="print"></mat-icon>Print View
    </a>
    <label class="bpx-check">
      <input
        type="checkbox"
        [checked]="printTruncatedReport"
        (change)="printTruncatedReport = $any($event.target).checked" />
      Print Truncated Report
    </label>
    }
    <a
      (click)="downloadReport()"
      class="bpx-btn"
      [class.bpx-btn--disabled]="!canDownloadReport"
      [attr.aria-disabled]="!canDownloadReport"
      [attr.tabindex]="canDownloadReport ? 0 : -1"
      [title]="reportButtonTooltip">
      <mat-icon fontIcon="picture_as_pdf"></mat-icon>Print Report
    </a>
  </div>
  }

  @if (isPrintMode) {
    @for (pageColumns of printPages; track pageColumns; let pageIndex = $index) {
    <div class="bpx-print-page" [class.bpx-print-page--last]="pageIndex === (printPages.length - 1)">
      @if (printPageCaption(pageIndex)) {
      <div class="bpx-print-page-caption">{{ printPageCaption(pageIndex) }}</div>
      }
      <ng-container *ngTemplateOutlet="assayTableTpl; context: { pageColumns: pageColumns }"></ng-container>
    </div>
    }
  } @else {
    <ng-container *ngTemplateOutlet="assayTableTpl; context: { pageColumns: calResponseCombinedData }"></ng-container>
    @if (!calResponseCombinedData.length) {
    <p class="bpx-empty">No assay results to display.</p>
    }
  }

  <ng-template #assayTableTpl let-pageColumns="pageColumns">
  <table #assaySummaryTable [attr.id]="isPrintMode ? null : tableId"
    class="bpx-report__table bpx-report__table--pin-first bpx-report__table--sticky-head assay-summary__table"
    [class.assay-summary-print]="isPrintMode">
    <thead class="bpx-report__head">
      <tr>
        <td class="!align-middle">KitLot#</td>
        <ng-container *ngFor="let reportContentItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
          <td [class.mean-column-border]="isMeanColumnAssay(reportContentItem)" class="!align-middle" [ngClass]="{ 'selected-kit-highlight' : (refKitLot !=='' && reportContentItem?.reportContentItems?.lot === refKitLot),
            'adjusted-column-highlight': !isFinal && reportContentItem.valueAssigned === 'AdjustedCalculate', 'final-column-highlight': isFinal && reportContentItem.valueAssigned === 'AdjustedCalculate'}">
            {{ reportContentItem.reportContentItems.lot }}
            <ng-container *ngIf="reportContentItem.valueAssigned === 'AdjustedCalculate'">
              <span class="block">{{ adjustedLabel }}</span>
            </ng-container>
          </td>
        </ng-container>
      </tr>
      <tr>
        <td>Instrument ID</td>
        <ng-container *ngFor="let reportContentItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
          <td [class.mean-column-border]="isMeanColumnAssay(reportContentItem)" [ngClass]="{ 'selected-kit-highlight' : (refKitLot !=='' && reportContentItem?.reportContentItems?.lot === refKitLot),
            'adjusted-column-highlight': !isFinal && reportContentItem.valueAssigned === 'AdjustedCalculate', 'final-column-highlight': isFinal && reportContentItem.valueAssigned === 'AdjustedCalculate'}">
            <span [class.mean-values-text]="isMeanColumnAssay(reportContentItem)">
              {{ isMeanColumnAssay(reportContentItem) ? 'Mean Values' : reportContentItem.reportContentItems.runId }}
            </span>
          </td>
        </ng-container>
      </tr>
      <tr>
        <td>Assay Name</td>
        <ng-container *ngFor="let reportContentItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
          <td [class.mean-column-border]="isMeanColumnAssay(reportContentItem)" [ngClass]="{ 'selected-kit-highlight' : (refKitLot !=='' && reportContentItem?.reportContentItems?.lot === refKitLot),
            'adjusted-column-highlight': !isFinal && reportContentItem.valueAssigned === 'AdjustedCalculate', 'final-column-highlight': isFinal && reportContentItem.valueAssigned === 'AdjustedCalculate'}">
            {{ reportContentItem.reportContentItems.assay }}
          </td>
        </ng-container>
      </tr>
      <tr>
        <td>Bead Region</td>
        <ng-container *ngFor="let reportContentItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
          <td [class.mean-column-border]="isMeanColumnAssay(reportContentItem)" [ngClass]="{ 'selected-kit-highlight' : (refKitLot !=='' && reportContentItem?.reportContentItems?.lot === refKitLot),
            'adjusted-column-highlight': !isFinal && reportContentItem.valueAssigned === 'AdjustedCalculate', 'final-column-highlight': isFinal && reportContentItem.valueAssigned === 'AdjustedCalculate'}">
            {{ reportContentItem.reportContentItems.region }}
          </td>
        </ng-container>
      </tr>
      <tr>
        <td>Units</td>
        <ng-container *ngFor="let reportContentItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
          <td [class.mean-column-border]="isMeanColumnAssay(reportContentItem)" [ngClass]="{ 'selected-kit-highlight' : (refKitLot !=='' && reportContentItem?.reportContentItems?.lot === refKitLot),
            'adjusted-column-highlight': !isFinal && reportContentItem.valueAssigned === 'AdjustedCalculate', 'final-column-highlight': isFinal && reportContentItem.valueAssigned === 'AdjustedCalculate'}">
            {{ getUnitsByRegion(reportContentItem.reportContentItems.region)}}
          </td>
        </ng-container>
      </tr>
      <tr>
        <td>Result Decimal Precision</td>
        <ng-container *ngFor="let reportContentItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
          <td [class.mean-column-border]="isMeanColumnAssay(reportContentItem)" [ngClass]="{ 'selected-kit-highlight' : (refKitLot !=='' && reportContentItem?.reportContentItems?.lot === refKitLot),
            'adjusted-column-highlight': !isFinal && reportContentItem.valueAssigned === 'AdjustedCalculate', 'final-column-highlight': isFinal && reportContentItem.valueAssigned === 'AdjustedCalculate'}">
            {{ reportContentItem.reportContentItems.resultDecimalPrecision }}
          </td>
        </ng-container>
      </tr>
      <tr>
        <td>User Defined Decimal Precision</td>
        <ng-container *ngFor="let reportContentItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
          <td [class.mean-column-border]="isMeanColumnAssay(reportContentItem)" [ngClass]="{ 'selected-kit-highlight' : (refKitLot !=='' && reportContentItem?.reportContentItems?.lot === refKitLot),
            'adjusted-column-highlight': !isFinal && reportContentItem.valueAssigned === 'AdjustedCalculate', 'final-column-highlight': isFinal && reportContentItem.valueAssigned === 'AdjustedCalculate'}">
            {{ reportContentItem.reportContentItems.userDefinedDecimalPrecision }}
          </td>
        </ng-container>
      </tr>
      <tr>
        <td>Result Type</td>
        <ng-container *ngFor="let reportContentItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
          <td [class.mean-column-border]="isMeanColumnAssay(reportContentItem)" [ngClass]="{ 'selected-kit-highlight' : (refKitLot !=='' && reportContentItem?.reportContentItems?.lot === refKitLot),
            'adjusted-column-highlight': !isFinal && reportContentItem.valueAssigned === 'AdjustedCalculate', 'final-column-highlight': isFinal && reportContentItem.valueAssigned === 'AdjustedCalculate'}">
            {{ reportContentItem.reportContentItems.resultType }}
          </td>
        </ng-container>
      </tr>
    </thead>
    <tbody class="print-section">
      @if(isPrintMode) {
      <tr class="subsection-header-print-firstrow bpx-report__section">
        <td class="subsection-header-cell">
          Summary Status
        </td>
        <td [attr.colspan]="(pageColumns.length || 0)">
        </td>
      </tr>
      } @else {
      <tr class="bpx-report__section" [ngClass]="{ 'subsection-header' : !isPrintMode, 'subsection-header-print2': isPrintMode }"
          [class.section-header--no-data]="!sectionHasData[0]"
          (click)="toggleSectionDisplay(0)"
          [title]="sectionHasData[0] ? 'Click to show/hide section' : 'No data for this section'">
        <td class="collapsed-section-header subsection-header-cell collapsed-section-label">
          Summary Status
        </td>

        <td [attr.colspan]="(pageColumns.length || 0)"></td>
      </tr>
      }
      <ng-container *ngIf="isSectionExpanded(0)">
        <!-- Summary Status rows stay detached while the section is collapsed to keep change detection light -->
        <tr>
          <td>Run Date</td>
          <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
            <td [class.mean-column-border]="isMeanColumnAssay(materialItem)"> {{ getPatientFileData('date') }} </td>
          </ng-container>
        </tr>
        @if (shouldRenderReportContentRow('beadCouplingDate')) {
        <tr>
          <td>Bead Coupling Date</td>
          <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
            <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">{{ displayOrDash(materialItem.reportContentItems.beadCouplingDate) }}</td>
          </ng-container>
        </tr>
        }
        @if (shouldRenderReportContentRow('coupledBeadLn')) {
        <tr>
          <td>Coupled Bead LN</td>
          <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
            <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">{{ displayOrDash(materialItem.reportContentItems.coupledBeadLn) }}</td>
          </ng-container>
        </tr>
        }
        @if (shouldRenderReportContentRow('dyedBeadLn')) {
        <tr>
          <td>Dyed Bead LN</td>
          <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
            <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">{{ displayOrDash(materialItem.reportContentItems.dyedBeadLn) }}</td>
          </ng-container>
        </tr>
        }
        @if (shouldRenderReportContentRow('progenitorLn')) {
        <tr>
          <td>Progenitor LN</td>
          <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
            <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">{{ displayOrDash(materialItem.reportContentItems.progenitorLn) }}</td>
          </ng-container>
        </tr>
        }
        @if (shouldRenderReportContentRow('antigenLn')) {
        <tr>
          <td>Antigen LN</td>
          <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
            <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">{{ displayOrDash(materialItem.reportContentItems.antigenLn) }}</td>
          </ng-container>
        </tr>
        }
        @if (shouldRenderReportContentRow('antigenLoadLn')) {
        <tr>
          <td>Antigen Loading</td>
          <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
            <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">{{ displayOrDash(materialItem.reportContentItems.antigenLoadLn) }}</td>
          </ng-container>
        </tr>
        }
        @if (shouldRenderReportContentRow('coupledBeadPn')) {
        <tr>
          <td>Coupled Bead PN</td>
          <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
            <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">{{ displayOrDash(materialItem.reportContentItems.coupledBeadPn) }}</td>
          </ng-container>
        </tr>
        }
        @if (shouldRenderReportContentRow('ligandPn')) {
        <tr>
          <td>Ligand PN</td>
          <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
            <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">{{ displayOrDash(materialItem.reportContentItems.ligandPn) }}</td>
          </ng-container>
        </tr>
        }
        @if (shouldRenderReportContentRow('beadReagentPn')) {
        <tr>
          <td>Bead Reagent PN</td>
          <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
            <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">{{ displayOrDash(materialItem.reportContentItems.beadReagentPn) }}</td>
          </ng-container>
        </tr>
        }
        @if (shouldRenderReportContentRow('description')) {
        <tr>
          <td>Description</td>
          <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
            <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">{{ displayOrDash(materialItem.reportContentItems.description) }}</td>
          </ng-container>
        </tr>
        }
        <ng-container *ngFor="let item of bulkMaterial; trackBy: trackBulkMaterial">
          @if (shouldRenderBulkMaterialRow(item.bulk_material_description)) {
          <tr>
            <td> {{item.bulk_material_description}} LN</td>
            <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
              <td [class.mean-column-border]="isMeanColumnAssay(materialItem)"> {{ displayOrDash(materialItem.reportContentItems[transformedVariableColumns(item.bulk_material_description)]) }} </td>
            </ng-container>
          </tr>
          }
        </ng-container>
        <tr>
          <td>Instrument</td>
          <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
            <td class="aa-instrument-cell" [class.mean-column-border]="isMeanColumnAssay(materialItem)"> {{ getPatientFileData('instrumentSerialNo') }} </td>
          </ng-container>
        </tr>
        <tr>
          <td>Calibrator Lot</td>
          <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
            <td [class.mean-column-border]="isMeanColumnAssay(materialItem)"> {{ getCalibratorLotForColumn(materialItem) }} </td>
          </ng-container>
        </tr>
        <tr>
          <td>Control Lot</td>
          <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
            <td [class.mean-column-border]="isMeanColumnAssay(materialItem)" *ngIf="qcLots.length"> {{ qcLots[0].masterLotNumber }} </td>
            <td *ngIf="!qcLots.length"> </td>
          </ng-container>
        </tr>
      </ng-container>
    </tbody>
    <tbody class="print-section">
      @if(isPrintMode && !shouldHideControlTestDataForTruncatedPrint()) {
      <tr class="subsection-header-print bpx-report__section">
        <td class="subsection-header-cell">
          Run Validity -
          <span [ngClass]="getStatusClassFromResult(runValidityStatus)">
            {{runValidityStatus}}
          </span>
        </td>
        <td [attr.colspan]="(pageColumns.length || 0)">
        </td>
      </tr>
      } @else {
      <tr class="bpx-report__section" [ngClass]="{ 'subsection-header' : !isPrintMode, 'subsection-header-print2': isPrintMode }"
          [class.section-header--no-data]="!sectionHasData[1]"
          (click)="toggleSectionDisplay(1)"
          [title]="sectionHasData[1] ? 'Click to show/hide section' : 'No data for this section'">
        <td class="collapsed-section-header subsection-header-cell collapsed-section-label">
          Run Validity -
          <span [ngClass]="getStatusClassFromResult(runValidityStatus)">
            {{runValidityStatus}}
          </span>
        </td>

        <td [attr.colspan]="(pageColumns.length || 0)"></td>
      </tr>
      }
      <ng-container *ngIf="isSectionExpanded(1)">
        <!-- Run Validity metrics guarded to prevent unnecessary recalculations while hidden -->
        <tr>
          <td>Kit Status PASS/FAIL/ALERT</td>
          <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
            <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">
              <span [ngClass]="getRunValidityStatusClass(materialItem, materialItem?.runStatus?.kitStatus)">
                {{ getRunValidityDisplay(materialItem, materialItem?.runStatus?.kitStatus) | uppercase}}
              </span>
            </td>
          </ng-container>
        </tr>
        <tr>
          <td>Calibrator Specs Status</td>
          <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
            <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">
              <span [ngClass]="getRunValidityStatusClass(materialItem, materialItem?.runStatus?.calibratorSpecStatus)">
                {{ getRunValidityDisplay(materialItem, materialItem?.runStatus?.calibratorSpecStatus) | uppercase}}
              </span>
            </td>
          </ng-container>
        </tr>
        <tr>
          <td>Patient Sample Specs Status</td>
          <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
            <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">
              <span [ngClass]="getRunValidityStatusClass(materialItem, materialItem?.runStatus?.patientSampleSpecStatus)">
                {{ getRunValidityDisplay(materialItem, materialItem?.runStatus?.patientSampleSpecStatus) | uppercase}}
              </span>
            </td>
          </ng-container>
        </tr>
        <tr>
          <td>Patient Sample Acceptance Range</td>
          <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
            <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">
              <span [ngClass]="getRunValidityStatusClass(materialItem, materialItem?.runStatus?.patientSampleAcceptanceRange)">
                {{ getRunValidityDisplay(materialItem, materialItem?.runStatus?.patientSampleAcceptanceRange) | uppercase}}
              </span>
            </td>
          </ng-container>
        </tr>
        <tr>
          <td>Patient Samples: # Run | # Specified</td>
          <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
            <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">
              {{ getRunValidityDisplay(materialItem, materialItem?.runStatus?.patientSamplesRun) }} | {{ getRunValidityDisplay(materialItem, materialItem?.runStatus?.patientSamplesSpecified) }}
            </td>
          </ng-container>
        </tr>
        <tr>
          <td>Negative Samples</td>
          <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
            <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">
              <span [ngClass]="getRunValidityStatusClass( materialItem, runValidityPassFailAlertCount( (materialItem?.regressionStats?.negativeSamplesPASS || 0), (materialItem?.regressionStats?.negativeSamplesFAILED || 0), (materialItem?.regressionStats?.negativeSamplesALERT || 0) ) )">
                {{
 getRunValidityDisplay(
                  materialItem,
                  runValidityPassFailAlertCount(
                    (materialItem?.regressionStats?.negativeSamplesPASS || 0),
                    (materialItem?.regressionStats?.negativeSamplesFAILED || 0),
                    (materialItem?.regressionStats?.negativeSamplesALERT || 0)
                  )
                )
                }}
              </span>

            </td>
          </ng-container>
        </tr>
        <tr>
          <td>Within Cut-off Range Samples</td>
          <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
            <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">
              <span [ngClass]="getRunValidityStatusClass( materialItem, runValidityPassFailAlertCount( (materialItem?.regressionStats?.cutOffSamplesPASS || 0), (materialItem?.regressionStats?.cutOffSamplesFail || 0), (materialItem?.regressionStats?.CutOffSamplesAlert || 0) ) )">
                {{
 getRunValidityDisplay(
                  materialItem,
                  runValidityPassFailAlertCount(
                    (materialItem?.regressionStats?.cutOffSamplesPASS || 0),
                    (materialItem?.regressionStats?.cutOffSamplesFail || 0),
                    (materialItem?.regressionStats?.CutOffSamplesAlert || 0)
                  )
                )
                }}
              </span>
            </td>
          </ng-container>
        </tr>
        <tr>
          <td>Positive Samples</td>
          <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
            <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">
              <span [ngClass]="getRunValidityStatusClass( materialItem, runValidityPassFailAlertCount( (materialItem?.regressionStats?.positiveSamplesPASS || 0), (materialItem?.regressionStats?.positiveSamplesFAILED || 0), (materialItem?.regressionStats?.positiveSamplesAlert || 0) ) )">
                {{
 getRunValidityDisplay(
                  materialItem,
                  runValidityPassFailAlertCount(
                    (materialItem?.regressionStats?.positiveSamplesPASS || 0),
                    (materialItem?.regressionStats?.positiveSamplesFAILED || 0),
                    (materialItem?.regressionStats?.positiveSamplesAlert || 0)
                  )
                )
                }}
              </span>
            </td>
          </ng-container>
        </tr>
        <tr>
          <td>Calibration Curve Validity</td>
          <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
            <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">
              <span [ngClass]="getRunValidityStatusClass(materialItem, materialItem?.runStatus?.calCurveInformation?.calCurveValidity)">
                {{ getRunValidityDisplay(materialItem, materialItem?.runStatus?.calCurveInformation?.calCurveValidity) | uppercase}}
              </span>
            </td>
          </ng-container>
        </tr>
        <tr>
          <td>Calibration Replicate # Validity</td>
          <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
            <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">
              <span [ngClass]="getRunValidityStatusClass(materialItem, materialItem?.runStatus?.calCurveInformation?.calReplicateValidity)">
                {{ getRunValidityDisplay(materialItem, materialItem?.runStatus?.calCurveInformation?.calReplicateValidity) | uppercase}}
              </span>
            </td>
          </ng-container>
        </tr>
        <tr>
          <td>Control Results Validity</td>
          <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
            <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">
              <span [ngClass]="getRunValidityStatusClass(materialItem, materialItem?.runStatus?.controlResultsValidity)">
                {{ getRunValidityDisplay(materialItem, materialItem?.runStatus?.controlResultsValidity) | uppercase}}
              </span>
            </td>
          </ng-container>
        </tr>
        <tr>
          <td>Sample Replicate # Validity</td>
          <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
            <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">
              <span [ngClass]="getRunValidityStatusClass(materialItem, materialItem?.runStatus?.sampleReplicateCountValidity)">
                {{ getRunValidityDisplay(materialItem, materialItem?.runStatus?.sampleReplicateCountValidity) | uppercase}}
              </span>
            </td>
          </ng-container>
        </tr>
        <tr>
          <td>Sample Replicate CV Validity</td>
          <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
            <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">
              <span [ngClass]="getRunValidityStatusClass(materialItem, materialItem?.runStatus?.sampleReplicateCVValidity)">
                {{ getRunValidityDisplay(materialItem, materialItem?.runStatus?.sampleReplicateCVValidity) | uppercase}}
              </span>
            </td>
          </ng-container>
        </tr>
        <tr>
          <td>Control Test Status</td>
          <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
            <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">
              <span [ngClass]="getRunValidityStatusClass(materialItem, materialItem?.runStatus?.controlTestStatus)">
                {{ getRunValidityDisplay(materialItem, materialItem?.runStatus?.controlTestStatus) | uppercase}}
              </span>
            </td>
          </ng-container>
        </tr>
        <tr *ngIf="!shouldHideForTruncatedPrint('# RVs Discarded: RV and Assay Errors')">
          <td># RVs Discarded: RV and Assay Errors</td>
          <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
            <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">
              {{ getRunValidityDisplay(materialItem, materialItem?.runStatus?.numRVsDiscardedAssayAndRvErrors) }}
            </td>
          </ng-container>
        </tr>
        <tr *ngIf="!shouldHideForTruncatedPrint('# RVs Discarded: Bead Count Errors')">
          <td># RVs Discarded: Bead Count Errors</td>
          <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
            <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">
              {{ getRunValidityDisplay(materialItem, materialItem?.runStatus?.numRVsDiscardedBeadCountErrors) }}
            </td>
          </ng-container>
        </tr>
        <tr *ngIf="!shouldHideForTruncatedPrint('# RVs Discarded: Cal Failed')">
          <td># RVs Discarded: Cal Failed</td>
          <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
            <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">
              {{ getRunValidityDisplay(materialItem, materialItem?.runStatus?.numRVsDiscardedCalFailed) }}
            </td>
          </ng-container>
        </tr>
        <tr>
          <td># Controls with Failed Status</td>
          <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
            <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">
              {{ getRunValidityDisplay(materialItem, materialItem?.runStatus?.numControlsDiscardedFailed) }}
            </td>
          </ng-container>
        </tr>
        <tr *ngIf="!shouldHideForTruncatedPrint('# RVs Discarded: Outlier')">
          <td># RVs Discarded: Outlier</td>
          <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
            <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">
              {{ getRunValidityDisplay(materialItem, materialItem?.runStatus?.numRVsDiscardedOutliers) }}
            </td>
          </ng-container>
        </tr>
        <tr *ngIf="!shouldHideForTruncatedPrint('# RVs Analyzed')">
          <td># RVs Analyzed</td>
          <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
            <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">
              {{ getRunValidityDisplay(materialItem, materialItem?.runStatus?.numRVsAnalyzed) }}
            </td>
          </ng-container>
        </tr>
        <!-- <tr>
    <td>Qualitative Patient Sample Status</td>
    <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
      <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">

      </td>
    </ng-container>
  </tr> -->
      </ng-container>
    </tbody>
    <tbody class="print-section">
      @if(isPrintMode && !shouldHideControlTestDataForTruncatedPrint()) {
      <tr class="subsection-header-print bpx-report__section">
        <td class="subsection-header-cell">
          Calibration Curve -
          <span [ngClass]="getStatusClassFromResult(calibrationCurveSectionStatus)">
            {{ calibrationCurveSectionStatus }}
          </span>
        </td>
        <td [attr.colspan]="(pageColumns.length || 0)">
        </td>
      </tr>
      } @else if(!shouldHideControlTestDataForTruncatedPrint()) {
      <tr class="bpx-report__section" [ngClass]="{ 'subsection-header' : !isPrintMode, 'subsection-header-print2': isPrintMode }"
          [class.section-header--no-data]="!sectionHasData[2]"
          (click)="toggleSectionDisplay(2)"
          [title]="sectionHasData[2] ? 'Click to show/hide section' : 'No data for this section'">
        <td class="collapsed-section-header subsection-header-cell collapsed-section-label">
          Calibration Curve -
          <span [ngClass]="getStatusClassFromResult(calibrationCurveSectionStatus)">
            {{ calibrationCurveSectionStatus }}
          </span>
        </td>

        <td [attr.colspan]="(pageColumns.length || 0)"></td>
      </tr>
      }
      <ng-container *ngIf="isSectionExpanded(2)">
        <!-- Calibration Curve details are only evaluated when the section is expanded -->
      <tr>
        <td>Low Assay Range</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
          <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">
            {{ displayOrDash(materialItem?.calibrationCurve?.assay_range_lower) }}
          </td>
        </ng-container>
      </tr>
      <tr>
        <td>High Assay Range</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
          <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">
            {{ displayOrDash(materialItem?.calibrationCurve?.assay_range_upper) }}
          </td>
        </ng-container>
      </tr>
      <tr>
        <td>Assay Cut-Off</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
          <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">
            {{ displayOrDash(materialItem?.calibrationCurve?.cut_off) }}
          </td>
        </ng-container>
      </tr>
      <tr>
        <td>Result Decimal Precision</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
          <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">
            {{ displayOrDash(materialItem?.calibrationCurve?.result_decimal_precision) }}
          </td>
        </ng-container>
      </tr>
      <tr>
        <td>Math Model</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
          <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">
            {{ displayOrDash(materialItem?.calibrationCurve?.math_model) }}
          </td>
        </ng-container>
      </tr>
      <tr>
        <td>Curve Direction</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
          <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">
            {{ displayOrDash(materialItem?.calibrationCurve?.curve_direction) }}
          </td>
        </ng-container>
      </tr>
      <tr>
        <td>Monotonic Pass/Fail</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
          <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">
            <span [ngClass]="getStatusClassFromResult(materialItem?.calibrationCurve?.monotonic)">
              {{ displayOrDash(materialItem?.calibrationCurve?.monotonic) | uppercase}}
            </span>
          </td>
        </ng-container>
      </tr>
      </ng-container>
    </tbody>
    <tbody class="print-section">
      @if(isPrintMode && !shouldHideControlTestDataForTruncatedPrint()) {
      <tr class="subsection-header-print bpx-report__section">
        <td class="subsection-header-cell">
          Calibration Curve Parameters -
          <span [ngClass]="getStatusClassFromResult(calCurveParameterStatus)">
            {{calCurveParameterStatus}}
          </span>
        </td>
        <td [attr.colspan]="(pageColumns.length || 0)">
        </td>
      </tr>
      } @else {
      <tr class="bpx-report__section" [ngClass]="{ 'subsection-header' : !isPrintMode, 'subsection-header-print2': isPrintMode }"
          [class.section-header--no-data]="!sectionHasData[3]"
          (click)="toggleSectionDisplay(3)"
          [title]="sectionHasData[3] ? 'Click to show/hide section' : 'No data for this section'">
        <td class="collapsed-section-header subsection-header-cell collapsed-section-label">
          Calibration Curve Parameters -
          <span [ngClass]="getStatusClassFromResult(calCurveParameterStatus)">
            {{calCurveParameterStatus}}
          </span>
        </td>

        <td [attr.colspan]="(pageColumns.length || 0)"></td>
      </tr>
      }
      <ng-container *ngIf="isSectionExpanded(3)">
        <!-- Calibration Curve Parameter section is lazy-rendered behind this guard -->
      <tr>
        <td>0 Concentration RFI</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
          <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">
            {{displayOrDash(materialItem?.runStatus?.calCurveInformation?.zeroConcentrationRfi)}}
          </td>
        </ng-container>
      </tr>
      <tr>
        <td>Pass/Fail Spec (0 Concentration RFI)</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
          <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">
            {{formatSpecRange(materialItem?.runStatus?.calCurveInformation?.zeroConcentrationRfiSpecMin,
              materialItem?.runStatus?.calCurveInformation?.zeroConcentrationRfiSpecMax)}}
          </td>
        </ng-container>
      </tr>
      <tr>
        <td>Alert Spec (0 Concentration RFI)</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
          <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">
            {{formatSpecRange(materialItem?.runStatus?.calCurveInformation?.zeroConcentrationRfiSpecAlertMin,
              materialItem?.runStatus?.calCurveInformation?.zeroConcentrationRfiSpecAlertMax)}}
          </td>
        </ng-container>
      </tr>
      <tr>
        <td>Pass/Fail (0 Concentration RFI)</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
          <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">
            <span [ngClass]="getStatusClassFromResult(materialItem?.runStatus?.calCurveInformation?.zeroConcentrationRfiResult)">
              {{displayOrDash(materialItem?.runStatus?.calCurveInformation?.zeroConcentrationRfiResult) | uppercase}}
            </span>
          </td>
        </ng-container>
      </tr>
      <tr>
        <td>Cut-Off RFI</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
          <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">
            {{displayOrDash(materialItem?.runStatus?.calCurveInformation?.cutOffRfi)}}
          </td>
        </ng-container>
      </tr>
      <tr>
        <td>Pass/Fail Spec (Cut-Off RFI)</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
          <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">
            {{formatSpecRange(materialItem?.runStatus?.calCurveInformation?.cutOffRfiSpecMin,
              materialItem?.runStatus?.calCurveInformation?.cutOffRfiSpecMax)}}
          </td>
        </ng-container>
      </tr>
      <tr>
        <td>Alert Spec (Cut-Off RFI)</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
          <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">
            {{formatSpecRange(materialItem?.runStatus?.calCurveInformation?.cutOffRfiSpecAlertMin,
              materialItem?.runStatus?.calCurveInformation?.cutOffRfiSpecAlertMax)}}
          </td>
        </ng-container>
      </tr>
      <tr>
        <td>Pass/Fail (Cut-Off RFI)</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
          <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">
            <span [ngClass]="getStatusClassFromResult(materialItem?.runStatus?.calCurveInformation?.cutOffRfiResult)">
              {{displayOrDash(materialItem?.runStatus?.calCurveInformation?.cutOffRfiResult) | uppercase}}
            </span>
          </td>
        </ng-container>
      </tr>
      <tr>
        <td>Estimated High Assay Range RFI</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
          <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">
            {{displayOrDash(materialItem?.runStatus?.calCurveInformation?.estimatedHighAssayRangeRfi)}}
          </td>
        </ng-container>
      </tr>
      <tr>
        <td>Pass/Fail Spec (Estimated High Assay Range)</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
          <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">
            {{formatSpecRange(materialItem?.runStatus?.calCurveInformation?.estimatedHighAssayRangeRfiSpecMin,
              materialItem?.runStatus?.calCurveInformation?.estimatedHighAssayRangeRfiSpecMax)}}
          </td>
        </ng-container>
      </tr>
      <tr>
        <td>Alert Spec (Estimated High Assay Range)</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
          <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">
            {{formatSpecRange(materialItem?.runStatus?.calCurveInformation?.estimatedHighAssayRangeRfiSpecAlertMin,
              materialItem?.runStatus?.calCurveInformation?.estimatedHighAssayRangeRfiSpecAlertMax)}}
          </td>
        </ng-container>
      </tr>
      <tr>
        <td>Pass/Fail (Estimated High Assay Range)</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
          <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">
            <span [ngClass]="getStatusClassFromResult(materialItem?.runStatus?.calCurveInformation?.estimatedHighAssayRangeRfiResult)">
              {{displayOrDash(materialItem?.runStatus?.calCurveInformation?.estimatedHighAssayRangeRfiResult) | uppercase}}
            </span>
          </td>
        </ng-container>
      </tr>
      <tr>
        <td>Percent Modulation</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
          <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">
            {{displayOrDash(materialItem?.runStatus?.calCurveInformation?.percentModulation)}}
          </td>
        </ng-container>
      </tr>
      <tr>
        <td>Pass/Fail Spec (percent modulation)</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
          <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">
            {{formatSpecRange(materialItem?.runStatus?.calCurveInformation?.percentModulationSpecMin,
              materialItem?.runStatus?.calCurveInformation?.percentModulationSpecMax)}}
          </td>
        </ng-container>
      </tr>
      <tr>
        <td>Alert Spec (percent modulation)</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
          <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">
            {{formatSpecRange(materialItem?.runStatus?.calCurveInformation?.percentModulationSpecAlertMin,
              materialItem?.runStatus?.calCurveInformation?.percentModulationSpecAlertMax)}}
          </td>
        </ng-container>
      </tr>
      <tr>
        <td>Pass/Fail (percent modulation)</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
          <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">
            <span [ngClass]="getStatusClassFromResult(materialItem?.runStatus?.calCurveInformation?.percentModulationResult)">
              {{displayOrDash(materialItem?.runStatus?.calCurveInformation?.percentModulationResult) | uppercase}}
            </span>
          </td>
        </ng-container>
      </tr>
      <tr>
        <td>Low End Separation</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
          <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">
            {{displayOrDash(materialItem?.runStatus?.calCurveInformation?.lowEndSeparation)}}
          </td>
        </ng-container>
      </tr>
      <tr>
        <td>Pass/Fail Spec (Low End Separation)</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
          <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">
            {{formatSpecRange(materialItem?.runStatus?.calCurveInformation?.lowEndSeparationSpecMin,
              materialItem?.runStatus?.calCurveInformation?.lowEndSeparationSpecMax)}}
          </td>
        </ng-container>
      </tr>
      <tr>
        <td>Alert Spec (Low End Separation)</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
          <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">
            {{formatSpecRange(materialItem?.runStatus?.calCurveInformation?.lowEndSeparationSpecAlertMin,
              materialItem?.runStatus?.calCurveInformation?.lowEndSeparationSpecAlertMax)}}
          </td>
        </ng-container>
      </tr>
      <tr>
        <td>Pass/Fail (Low End Separation)</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
          <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">
            <span [ngClass]="getStatusClassFromResult(materialItem?.runStatus?.calCurveInformation?.lowEndSeparationResult)">
              {{displayOrDash(materialItem?.runStatus?.calCurveInformation?.lowEndSeparationResult) | uppercase}}
            </span>
          </td>
        </ng-container>
      </tr>
      <tr>
        <td>High End Separation</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
          <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">
            {{displayOrDash(materialItem?.runStatus?.calCurveInformation?.highEndSeparation)}}
          </td>
        </ng-container>
      </tr>
      <tr>
        <td>Pass/Fail Spec (High End Separation)</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
          <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">
            {{formatSpecRange(materialItem?.runStatus?.calCurveInformation?.highEndSeparationSpecMin,
              materialItem?.runStatus?.calCurveInformation?.highEndSeparationSpecMax)}}
          </td>
        </ng-container>
      </tr>
      <tr>
        <td>Alert Spec (High End Separation)</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
          <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">
            {{formatSpecRange(materialItem?.runStatus?.calCurveInformation?.highEndSeparationSpecAlertMin,
              materialItem?.runStatus?.calCurveInformation?.highEndSeparationSpecAlertMax)}}
          </td>
        </ng-container>
      </tr>
      <tr>
        <td>Pass/Fail (High End Separation)</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
          <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">
            <span [ngClass]="getStatusClassFromResult(materialItem?.runStatus?.calCurveInformation?.highEndSeparationResult)">
              {{displayOrDash(materialItem?.runStatus?.calCurveInformation?.highEndSeparationResult) | uppercase}}
            </span>
          </td>
        </ng-container>
      </tr>
      <tr>
        <td>Calibrator Level for Bead to Bead CV</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
          <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">
            {{displayOrDash(materialItem?.calibrationCurve?.cal_level_for_cv)}}
          </td>
        </ng-container>
      </tr>
      <tr>
        <td>Calibrator Bead to Bead CV</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
          <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">
            {{displayOrDash(materialItem?.runStatus?.calCurveInformation?.calBeadToBeadCV)}}
          </td>
        </ng-container>
      </tr>
      <tr>
        <td>Pass/Fail Spec (Bead to Bead CV)</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
          <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">
            {{formatSpecRange(materialItem?.runStatus?.calCurveInformation?.calBeadToBeadCVSpecMin,
              materialItem?.runStatus?.calCurveInformation?.calBeadToBeadCVSpecMax)}}
          </td>
        </ng-container>
      </tr>
      <tr>
        <td>Alert Spec (Bead to Bead CV)</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
          <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">
            {{formatSpecRange(materialItem?.runStatus?.calCurveInformation?.calBeadToBeadCVSpecAlertMin,
              materialItem?.runStatus?.calCurveInformation?.calBeadToBeadCVSpecAlertMax)}}
          </td>
        </ng-container>
      </tr>
      <tr>
        <td>Pass/Fail (Bead to Bead CV)</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
          <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">
            <span [ngClass]="getStatusClassFromResult(materialItem?.runStatus?.calCurveInformation?.calBeadToBeadCVResult)">
              {{displayOrDash(materialItem?.runStatus?.calCurveInformation?.calBeadToBeadCVResult) | uppercase}}
            </span>
          </td>
        </ng-container>
      </tr>
      </ng-container>
    </tbody>
    <tbody class="print-section">
      @if(isPrintMode) {
      <tr class="subsection-header-print bpx-report__section">
        <td class="subsection-header-cell">
          Control QC Data -
          <span [ngClass]="getStatusClassFromResult(controlQcSectionStatus)">
            {{ controlQcSectionStatus }}
          </span>
        </td>
        <td [attr.colspan]="(pageColumns.length || 0)">
        </td>
      </tr>
      } @else {
      <tr class="bpx-report__section" [ngClass]="{ 'subsection-header' : !isPrintMode, 'subsection-header-print2': isPrintMode }"
          [class.section-header--no-data]="!sectionHasData[4]"
          (click)="toggleSectionDisplay(4)"
          [title]="sectionHasData[4] ? 'Click to show/hide section' : 'No data for this section'">
        <td class="collapsed-section-header subsection-header-cell collapsed-section-label">
          Control QC Data -
          <span [ngClass]="getStatusClassFromResult(controlQcSectionStatus)">
            {{ controlQcSectionStatus }}
          </span>
        </td>

        <td [attr.colspan]="(pageColumns.length || 0)"></td>
      </tr>
      }
      <ng-container *ngIf="isSectionExpanded(4)">
        <!-- Control QC Data rows stay detached until the user expands them -->
      <tr>
        <td>Control Barcodes</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
          <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">
            {{ getControlLotNumber(materialItem) }}
          </td>
        </ng-container>
      </tr>
      <tr *ngFor="let level of controlQcLevels; trackBy: trackByValue">
        <td class="control-level-label">{{ level }}</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
          <td class="control-barcode-cell" [class.mean-column-border]="isMeanColumnAssay(materialItem)">
            {{ getControlBarcode(materialItem, level) }}
          </td>
        </ng-container>
      </tr>
      <tr class="control-section-row">
        <td>Control Test Result</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
          <td [class.mean-column-border]="isMeanColumnAssay(materialItem)"></td>
        </ng-container>
      </tr>
      <tr *ngFor="let level of controlQcLevels; trackBy: trackByValue">
        <td class="control-level-label">{{ level }}</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
          <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">
            {{ getControlTestResult(materialItem, level) }}
          </td>
        </ng-container>
      </tr>
      <tr class="control-section-row">
        <td>Control Criteria (Pass/Fail)</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
          <td [class.mean-column-border]="isMeanColumnAssay(materialItem)"></td>
        </ng-container>
      </tr>
      <tr *ngFor="let level of controlQcLevels; trackBy: trackByValue">
        <td class="control-level-label">{{ level }}</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
          <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">
            <ng-container *ngIf="getControlCriteriaDisplay(materialItem, level) as criteria">
              <div *ngIf="criteria !== '-'">
                <span class="control-criteria-sign">±</span>
                <span>{{ criteria }}</span>
              </div>
              <span *ngIf="criteria === '-'">-</span>
            </ng-container>
          </td>
        </ng-container>
      </tr>
      <tr class="control-section-row">
        <td>Control Ranges (Pass/Fail)</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
          <td [class.mean-column-border]="isMeanColumnAssay(materialItem)"></td>
        </ng-container>
      </tr>
      <tr *ngFor="let level of controlQcLevels; trackBy: trackByValue">
        <td class="control-level-label">{{ level }}</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
          <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">
            {{ getControlRange(materialItem, level) }}
          </td>
        </ng-container>
      </tr>
      <tr class="control-section-row">
        <td>Control Result (Pass/Fail)</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
          <td [class.mean-column-border]="isMeanColumnAssay(materialItem)"></td>
        </ng-container>
      </tr>
      <tr *ngFor="let level of controlQcLevels; trackBy: trackByValue">
        <td class="control-level-label">{{ level }}</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
          <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">
            <ng-container *ngIf="getControlStatus(materialItem, level) as controlStatus">
              <span *ngIf="controlStatus !== '-'" [ngClass]="getStatusClassFromResult(controlStatus)">
                {{ controlStatus | uppercase }}
              </span>
              <span *ngIf="controlStatus === '-'">-</span>
            </ng-container>
          </td>
        </ng-container>
      </tr>
      </ng-container>
    </tbody>
    <tbody class="print-section">
      @if(isPrintMode) {
      <tr class="subsection-header-print bpx-report__section">
        <td class="subsection-header-cell">
          Control Test Data -
          <span [ngClass]="getStatusClassFromResult(isControlAssignmentRun() ? 'NA' : controlTestSectionStatus)">
            {{ isControlAssignmentRun() ? 'NA' : controlTestSectionStatus }}
          </span>
        </td>
        <td [attr.colspan]="(pageColumns.length || 0)">
        </td>
      </tr>
      } @else if(!shouldHideControlTestDataForTruncatedPrint()) {
      <tr class="bpx-report__section" [ngClass]="{ 'subsection-header' : !isPrintMode, 'subsection-header-print2': isPrintMode }"
          [class.section-header--no-data]="!sectionHasData[5]"
          (click)="toggleSectionDisplay(5)"
          [title]="sectionHasData[5] ? 'Click to show/hide section' : 'No data for this section'">
        <td class="collapsed-section-header subsection-header-cell collapsed-section-label">
          Control Test Data -
          <span [ngClass]="getStatusClassFromResult(isControlAssignmentRun() ? 'NA' : controlTestSectionStatus)">
            {{ isControlAssignmentRun() ? 'NA' : controlTestSectionStatus }}
          </span>
        </td>

        <td [attr.colspan]="(pageColumns.length || 0)"></td>
      </tr>
      }
      <ng-container *ngIf="isSectionExpanded(5) && !shouldHideControlTestDataForTruncatedPrint()">
        <!-- Control Test Data rows are also gated to minimize DOM churn -->
        <ng-container *ngFor="let lot of controlTestLots; trackBy: trackByValue">
          <tr>
            <td>Control Barcodes</td>
            <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
              <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">{{ getControlTestLotDisplay(materialItem, lot) }}</td>
            </ng-container>
          </tr>
          <ng-container *ngFor="let level of controlTestLevels; trackBy: trackByValue">
            <tr>
              <td class="control-level-label">{{ level }}</td>
              <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
                <td class="control-barcode-cell" [class.mean-column-border]="isMeanColumnAssay(materialItem)">{{ getControlTestBarcode(materialItem, lot, level) }}</td>
              </ng-container>
            </tr>
          </ng-container>
          <tr class="control-section-row">
            <td>Control Test Result</td>
            <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
              <td [class.mean-column-border]="isMeanColumnAssay(materialItem)"></td>
            </ng-container>
          </tr>
          <ng-container *ngFor="let level of controlTestLevels; trackBy: trackByValue">
            <tr>
              <td class="control-level-label">{{ level }}</td>
              <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
                <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">{{ getControlTestResultValue(materialItem, lot, level) }}</td>
              </ng-container>
            </tr>
          </ng-container>
          <tr class="control-section-row">
            <td>Control Range Criteria (Alert)</td>
            <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
              <td [class.mean-column-border]="isMeanColumnAssay(materialItem)"></td>
            </ng-container>
          </tr>
          <ng-container *ngFor="let level of controlTestLevels; trackBy: trackByValue">
            <tr>
              <td class="control-level-label">{{ level }}</td>
              <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
                <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">
                  <ng-container *ngIf="getControlTestCriteriaAlert(materialItem, lot, level) as alertCriteria">
                    <div *ngIf="alertCriteria !== '-'">
                      <span class="control-criteria-sign">±</span>
                      <span>{{ alertCriteria }}</span>
                    </div>
                    <span *ngIf="alertCriteria === '-'">-</span>
                  </ng-container>
                </td>
              </ng-container>
            </tr>
          </ng-container>
          <tr class="control-section-row">
            <td>Control Ranges (Alert)</td>
            <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
              <td [class.mean-column-border]="isMeanColumnAssay(materialItem)"></td>
            </ng-container>
          </tr>
          <ng-container *ngFor="let level of controlTestLevels; trackBy: trackByValue">
            <tr>
              <td class="control-level-label">{{ level }}</td>
              <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
                <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">{{ getControlTestRangeAlert(materialItem, lot, level) }}</td>
              </ng-container>
            </tr>
          </ng-container>
          <tr class="control-section-row">
            <td>Control Result (Alert)</td>
            <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
              <td [class.mean-column-border]="isMeanColumnAssay(materialItem)"></td>
            </ng-container>
          </tr>
          <ng-container *ngFor="let level of controlTestLevels; trackBy: trackByValue">
            <tr>
              <td class="control-level-label">{{ level }}</td>
              <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
                <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">
                  <ng-container *ngIf="getControlTestStatusAlert(materialItem, lot, level) as alertStatus">
                    <span *ngIf="alertStatus !== '-'" [ngClass]="getStatusClassFromResult(alertStatus)">
                      {{ alertStatus | uppercase }}
                    </span>
                    <span *ngIf="alertStatus === '-'">-</span>
                  </ng-container>
                </td>
              </ng-container>
            </tr>
          </ng-container>
          <tr class="control-section-row">
            <td>Control Range Criteria (Pass/Fail)</td>
            <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
              <td [class.mean-column-border]="isMeanColumnAssay(materialItem)"></td>
            </ng-container>
          </tr>
          <ng-container *ngFor="let level of controlTestLevels; trackBy: trackByValue">
            <tr>
              <td class="control-level-label">{{ level }}</td>
              <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
                <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">
                  <ng-container *ngIf="getControlTestCriteriaPass(materialItem, lot, level) as passCriteria">
                    <div *ngIf="passCriteria !== '-'">
                      <span class="control-criteria-sign">±</span>
                      <span>{{ passCriteria }}</span>
                    </div>
                    <span *ngIf="passCriteria === '-'">-</span>
                  </ng-container>
                </td>
              </ng-container>
            </tr>
          </ng-container>
          <tr class="control-section-row">
            <td>Control Ranges (Pass/Fail)</td>
            <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
              <td [class.mean-column-border]="isMeanColumnAssay(materialItem)"></td>
            </ng-container>
          </tr>
          <ng-container *ngFor="let level of controlTestLevels; trackBy: trackByValue">
            <tr>
              <td class="control-level-label">{{ level }}</td>
              <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
                <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">{{ getControlTestRangePass(materialItem, lot, level) }}</td>
              </ng-container>
            </tr>
          </ng-container>
          <tr class="control-section-row">
            <td>Control Result (Pass/Fail)</td>
            <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
              <td [class.mean-column-border]="isMeanColumnAssay(materialItem)"></td>
            </ng-container>
          </tr>
          <ng-container *ngFor="let level of controlTestLevels">
            <tr>
              <td class="control-level-label">{{ level }}</td>
              <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
                <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">
                  <ng-container *ngIf="getControlTestStatusPass(materialItem, lot, level) as testStatus">
                    <span *ngIf="testStatus !== '-'" [ngClass]="getStatusClassFromResult(testStatus)">
                      {{ testStatus | uppercase }}
                    </span>
                    <span *ngIf="testStatus === '-'">-</span>
                  </ng-container>
                </td>
              </ng-container>
            </tr>
          </ng-container>
        </ng-container>
      </ng-container>

    </tbody>
      @if (shouldRenderRangeSections) {
      @for (rangeItem of ranges; track rangeItem;) {
    <tbody class="print-section">
      @if(isPrintMode) {
      <tr class="subsection-header-print bpx-report__section">
        <td class="subsection-header-cell">
          <ng-container *ngIf="regressionRangeStatus && regressionRangeStatus[rangeItem - 1]">
            Range {{ rangeItem }} -
            <span [ngClass]="getStatusClassFromResult(regressionRangeStatus[rangeItem-1].status)">
              {{ regressionRangeStatus[rangeItem-1].status || 'NA' }}
            </span>
          </ng-container>
          <ng-container *ngIf="!regressionRangeStatus || !regressionRangeStatus[rangeItem - 1]">
            Range {{ rangeItem }} - NA
          </ng-container>
        </td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
          <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">
          </td>
        </ng-container>
      </tr>
      } @else {
      <tr class="bpx-report__section" [ngClass]="{ 'subsection-header' : !isPrintMode, 'subsection-header-print2': isPrintMode }"
          [class.section-header--no-data]="!sectionHasData[5 + rangeItem]"
          (click)="toggleSectionDisplay(5 + rangeItem)"
          [title]="sectionHasData[5 + rangeItem] ? 'Click to show/hide section' : 'No data for this section'">
        <td class="collapsed-section-header subsection-header-cell collapsed-section-label">
          <ng-container *ngIf="regressionRangeStatus && regressionRangeStatus[rangeItem - 1]">
            Range {{ rangeItem }} -
            <span [ngClass]="getStatusClassFromResult(regressionRangeStatus[rangeItem-1].status)">
              {{ regressionRangeStatus[rangeItem-1].status || 'NA' }}
            </span>
          </ng-container>
          <ng-container *ngIf="!regressionRangeStatus || !regressionRangeStatus[rangeItem - 1]">
            Range {{ rangeItem }} - NA
          </ng-container>
        </td>

        <td [attr.colspan]="(pageColumns.length || 0)"></td>
      </tr>
      }
      <ng-container *ngIf="isSectionExpanded(5 + rangeItem)">
        <!-- Each bias/ratio range renders on demand so collapsed panels do zero work -->
      <tr *ngIf="shouldRenderRangeRowForTruncatedPrint('Slope')">
        <td>Slope</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
          <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">
            {{ formatRangeNumber(materialItem, rangeItem, 'slope') }}
          </td>
        </ng-container>
      </tr>
      <tr *ngIf="shouldRenderRangeRowForTruncatedPrint('95% CI of slope')">
        <td>95% CI of slope</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
          <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">
            {{ displayOrDash(getRangeData(materialItem, rangeItem, 'slopeCI')) }}
          </td>
        </ng-container>
      </tr>
      <tr *ngIf="shouldRenderRangeRowForTruncatedPrint('Pass/Fail/Alert')">
        <td>Pass/Fail/Alert</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
          <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">
            <ng-container *ngIf="getProcessedRangeData(materialItem, rangeItem, 'SlopeLimitResult') as slopeResult; else slopeDash">
              <span [ngClass]="getStatusClassFromResult(slopeResult)">
                {{ slopeResult }}
              </span>
            </ng-container>
            <ng-template #slopeDash>-</ng-template>
          </td>
        </ng-container>
      </tr>
      <tr *ngIf="shouldRenderRangeRowForTruncatedPrint('Alert Spec.')">
        <td>Alert Spec.</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
          <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">
            {{ formatRangeSpan(materialItem, rangeItem, 'SlopeLimitLowSpecAlert', 'SlopeLimitHighSpecAlert') }}
          </td>
        </ng-container>
      </tr>
      <tr *ngIf="shouldRenderRangeRowForTruncatedPrint('Pass/Fail Spec.')">
        <td>Pass/Fail Spec.</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
          <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">
            {{ formatRangeSpan(materialItem, rangeItem, 'SlopeLimitLowSpec', 'SlopeLimitHighSpec') }}
          </td>
        </ng-container>
      </tr>
      <tr *ngIf="shouldRenderRangeRowForTruncatedPrint('Intercept')">
        <td>Intercept</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
          <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">
            {{ formatRangeNumber(materialItem, rangeItem, 'intercept') }}
          </td>
        </ng-container>
      </tr>
      <tr *ngIf="shouldRenderRangeRowForTruncatedPrint('95% CI of intercept')">
        <td>95% CI of intercept</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
          <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">
            {{ displayOrDash(getRangeData(materialItem, rangeItem, 'interceptCI')) }}
          </td>
        </ng-container>
      </tr>
      <tr *ngIf="shouldRenderRangeRowForTruncatedPrint('Pass/Fail/Alert')">
        <td>Pass/Fail/Alert</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
          <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">
            <ng-container *ngIf="getProcessedRangeData(materialItem, rangeItem, 'InterceptLimitResult') as interceptResult; else interceptDash">
              <span [ngClass]="getStatusClassFromResult(interceptResult)">
                {{ interceptResult }}
              </span>
            </ng-container>
            <ng-template #interceptDash>-</ng-template>
          </td>
        </ng-container>
      </tr>
      <tr *ngIf="shouldRenderRangeRowForTruncatedPrint('Alert Spec.')">
        <td>Alert Spec.</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
          <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">
            {{ formatRangeSpan(materialItem, rangeItem, 'InterceptLimitLowSpecAlert', 'InterceptLimitHighSpecAlert') }}
          </td>
        </ng-container>
      </tr>
      <tr *ngIf="shouldRenderRangeRowForTruncatedPrint('Pass/Fail Spec.')">
        <td>Pass/Fail Spec.</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
          <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">
            {{ formatRangeSpan(materialItem, rangeItem, 'InterceptLimitLowSpec', 'InterceptLimitHighSpec') }}
          </td>
        </ng-container>
      </tr>
      <tr *ngIf="shouldRenderRangeRowForTruncatedPrint('Correlation')">
        <td>Correlation</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
          <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">
            {{ formatRangeNumber(materialItem, rangeItem, 'correlation') }}
          </td>
        </ng-container>
      </tr>
      <tr *ngIf="shouldRenderRangeRowForTruncatedPrint('Pass/Fail/Alert')">
        <td>Pass/Fail/Alert</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
          <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">
            <ng-container *ngIf="getProcessedRangeData(materialItem, rangeItem, 'CorrelationLimitResult') as correlationResult; else correlationDash">
              <span [ngClass]="getStatusClassFromResult(correlationResult)">
                {{ correlationResult }}
              </span>
            </ng-container>
            <ng-template #correlationDash>-</ng-template>
          </td>
        </ng-container>
      </tr>
      <tr *ngIf="shouldRenderRangeRowForTruncatedPrint('Alert Spec.')">
        <td>Alert Spec.</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
          <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">
            {{ displayOrDash(getRangeData(materialItem, rangeItem, 'CorrelationLimitSpecAlert')) }}
          </td>
        </ng-container>
      </tr>
      <tr *ngIf="shouldRenderRangeRowForTruncatedPrint('Pass/Fail Spec.')">
        <td>Pass/Fail Spec.</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
          <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">
            {{ displayOrDash(getRangeData(materialItem, rangeItem, 'CorrelationLimitSpec')) }}
          </td>
        </ng-container>
      </tr>
      <tr *ngIf="shouldRenderRangeRowForTruncatedPrint('SEE')">
        <td>SEE</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
          <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">
            {{ formatRangeNumber(materialItem, rangeItem, 'see') }}
          </td>
        </ng-container>
      </tr>
      <tr *ngIf="shouldRenderRangeRowForTruncatedPrint('Correlation Coefficient R2')">
        <td>Correlation Coefficient R<sup>2</sup></td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
          <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">
            {{ getRsquared(materialItem, rangeItem) }}
          </td>
        </ng-container>
      </tr>
      <tr *ngIf="shouldRenderRangeRowForTruncatedPrint('Bias Type')">
        <td>Bias Type</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
          <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">
            {{ displayOrDash(getRangeData(materialItem, rangeItem, 'biasType')) }}
          </td>
        </ng-container>
      </tr>
      <tr *ngIf="shouldRenderRangeRowForTruncatedPrint('Mean')">
        <td>Mean</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
          <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">
            {{ formatRangeNumber(materialItem, rangeItem, 'meanBias') }}
          </td>
        </ng-container>
      </tr>
      <tr *ngIf="shouldRenderRangeRowForTruncatedPrint('95% CI of Mean Bias')">
        <td>95% CI of Mean Bias</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
          <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">
            {{ displayOrDash(getRangeData(materialItem, rangeItem, 'meanBiasCI')) }}
          </td>
        </ng-container>
      </tr>
      <tr *ngIf="shouldRenderRangeRowForTruncatedPrint('Pass/Fail/Alert')">
        <td>Pass/Fail/Alert</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
          <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">
            <ng-container *ngIf="getProcessedRangeData(materialItem, rangeItem, 'meanBiasResult') as meanResult; else meanDash">
              <span [ngClass]="getStatusClassFromResult(meanResult)">
                {{ meanResult }}
              </span>
            </ng-container>
            <ng-template #meanDash>-</ng-template>
          </td>
        </ng-container>
      </tr>
      <tr *ngIf="shouldRenderRangeRowForTruncatedPrint('Alert Spec.')">
        <td>Alert Spec.</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
          <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">
            {{ formatRangeSpan(materialItem, rangeItem, 'meanBiasLowSpecAlert', 'meanBiasHighSpecAlert') }}
          </td>
        </ng-container>
      </tr>
      <tr *ngIf="shouldRenderRangeRowForTruncatedPrint('Pass/Fail Spec.')">
        <td>Pass/Fail Spec.</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
          <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">
            {{ formatRangeSpan(materialItem, rangeItem, 'meanBiasLowSpec', 'meanBiasHighSpec') }}
          </td>
        </ng-container>
      </tr>
      <tr *ngIf="shouldRenderRangeRowForTruncatedPrint('Limit of Agreement P/F/A')">
        <td>Limit of Agreement P/F/A</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
          <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">
            <ng-container *ngIf="getProcessedRangeData(materialItem, rangeItem, 'limitOfAgreementResult') as loaResult; else loaDash">
              <span [ngClass]="getStatusClassFromResult(loaResult)">
                {{ loaResult }}
              </span>
            </ng-container>
            <ng-template #loaDash>-</ng-template>
          </td>
        </ng-container>
      </tr>
      <tr *ngIf="shouldRenderRangeRowForTruncatedPrint('Low Limits of Agreement')">
        <td>Low Limits of Agreement</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
          <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">
            {{ formatRangeNumber(materialItem, rangeItem, 'lowLimitOfAgreement') }}
          </td>
        </ng-container>
      </tr>
      <tr *ngIf="shouldRenderRangeRowForTruncatedPrint('High Limits of Agreement')">
        <td>High Limits of Agreement</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
          <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">
            {{ formatRangeNumber(materialItem, rangeItem, 'highLimitOfAgreement') }}
          </td>
        </ng-container>
      </tr>
      <tr *ngIf="shouldRenderRangeRowForTruncatedPrint('Pass/Fail Spec')">
        <td>Pass/Fail Spec</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
          <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">
            {{ formatRangeSpan(materialItem, rangeItem, 'limitOfAgreementLowSpec', 'limitOfAgreementHighSpec') }}
          </td>
        </ng-container>
      </tr>
      <tr *ngIf="shouldRenderRangeRowForTruncatedPrint('Standard Deviation')">
        <td>Standard Deviation</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
          <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">
            {{ formatRangeNumber(materialItem, rangeItem, 'sd') }}
          </td>
        </ng-container>
      </tr>
      <tr *ngIf="shouldRenderRangeRowForTruncatedPrint('Standard Error (SE)')">
        <td>Standard Error (SE)</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
          <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">
            {{ formatRangeNumber(materialItem, rangeItem, 'se') }}
          </td>
        </ng-container>
      </tr>
      <tr *ngIf="shouldRenderRangeRowForTruncatedPrint('1.96*STD')">
        <td>1.96*STD</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
          <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">
            {{ getScaledRangeValue(materialItem, rangeItem, 'sd', 1.96) }}
          </td>
        </ng-container>
      </tr>
      <tr *ngIf="shouldRenderRangeRowForTruncatedPrint('1.96*SE')">
        <td>1.96*SE</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
          <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">
            {{ getScaledRangeValue(materialItem, rangeItem, 'se', 1.96) }}
          </td>
        </ng-container>
      </tr>
      <tr *ngIf="shouldRenderRangeRowForTruncatedPrint('DF')">
        <td>DF</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
          <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">
            {{ formatRangeNumber(materialItem, rangeItem, 'dF') }}
          </td>
        </ng-container>
      </tr>
      <tr *ngIf="shouldRenderRangeRowForTruncatedPrint('T-Statistic')">
        <td>T-Statistic</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
          <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">
            {{ formatRangeNumber(materialItem, rangeItem, 'tStat') }}
          </td>
        </ng-container>
      </tr>
      <tr *ngIf="shouldRenderRangeRowForTruncatedPrint('T-Critical')">
        <td>T-Critical</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
          <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">
            {{ formatRangeNumber(materialItem, rangeItem, 'tCritical') }}
          </td>
        </ng-container>
      </tr>
      <tr *ngIf="shouldRenderRangeRowForTruncatedPrint('P')">
        <td>P</td>
        <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackAssayRow;" class="mt-6">
          <td [class.mean-column-border]="isMeanColumnAssay(materialItem)">
            {{ formatRangeNumber(materialItem, rangeItem, 'p') }}
          </td>
        </ng-container>
      </tr>
      </ng-container>
    </tbody>
        <tfoot class="bpx-print-spacer-footer">
          <tr>
            <td [attr.colspan]="(pageColumns.length || 0) + 1">
              <div class="bpx-print-footer-spacer" aria-hidden="true"></div>
            </td>
          </tr>
        </tfoot>
    }
    }

  </table>
  </ng-template>
</div>
  </div>
</div>

@if (isPrintMode) {
<div class="header">
  Bio-Rad Laboratories<br />
  Redmond, WA
</div>
<div class="print-footer-cutoff" aria-hidden="true"></div>
<div class="footer">
  <div class="print-footer-left">
    {{ studyName || '-' }}<br />
    {{ (panelName$ | async) || '-' }} : Spec Rev {{ specVersion || '-' }}<br />
    Web App Version: {{ appVersion || '-' }}
  </div>
</div>
}
